import { render, staticRenderFns } from "./QuizListYearRootView.vue?vue&type=template&id=abe01e2c"
import script from "./QuizListYearRootView.vue?vue&type=script&lang=js"
export * from "./QuizListYearRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports